import React from "react";
import { useTranslation } from "react-i18next";

import { Grid, Typography } from "@mui/material";

import "./view.css";

interface ViewContactDetailsProps {
  contactUsData: any;
}

const ViewContactDetails: React.FC<ViewContactDetailsProps> = ({ contactUsData }) => {
  const { t } = useTranslation("translation");

  return (
    <Grid container>
      <Grid container spacing={3} className='row-spacing'>
        <Grid item xs={12} sm={3}>
          <Typography className='field-title'>{t("name")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-value'>{contactUsData?.name}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-title'>{t("email")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-value'>{contactUsData?.email}</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} className='row-spacing'>
        <Grid item xs={12} sm={3}>
          <Typography className='field-title'>{t("phoneNumber")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-value'>{contactUsData?.phoneNumber}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-title'>{t("subject")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-value'>{contactUsData?.subject}</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} className='row-spacing'>
        <Grid item xs={12} sm={3}>
          <Typography className='field-title'>{t("createdAt")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-value'>{contactUsData?.createdAt}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-title'>{t("updatedAt")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-value'>{contactUsData?.updatedAt}</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} className='row-spacing'>
        <Grid item xs={12} sm={3}>
          <Typography className='field-title'>{t("status")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-value'>{contactUsData?.status}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-title'>{t("message")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-value'>{contactUsData?.message}</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} className='row-spacing'>
        <Grid item xs={12} sm={3}>
          <Typography className='field-title'>{t("businessName")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className='field-value'>{contactUsData?.businessName}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ViewContactDetails;
